import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Standard from './Standard'

const Time = props => {
  const {
    validations,
    onChange,
    onBlur,
    value: _value,
    required,
    allowDefaultZero,
    ...other
  } = props

  const [value, setValue] = useState(_value)

  useEffect(() => {
    setValue(!allowDefaultZero && _value === '00:00' ? '' : _value)
  }, [_value])

  const handleOnChange = (e, { value }, valid) => {
    const editedValue = edit(value)
    setValue(editedValue)
    onChange(e, { value: editedValue }, isValid(value))
  }

  const handleOnBlur = (e, { value }, valid) => {
    const editedValue = edit(value)
    setValue(editedValue)
    onBlur(e, { value: editedValue }, isValid(value))
  }

  const isValid = val => {
    if (required && (!val || val === '')) return false
    if (!val || val === '') return true

    const plain = val.toString().replace(/:/g, '')
    return plain.match(/[0-9]{2}[0-5][0-9]/) ? true : false
  }

  const edit = val => {
    if (!isValid(val)) return val || ''
    if (!val || val === '') return val
    const plain = val.toString().replace(/:/g, '')
    return plain.slice(0, 2) + ':' + plain.slice(2)
  }

  return (
    <Standard
      {...other}
      type='tel'
      validations={_.merge({}, validations, {
        isTime: true,
        maxLength: 5,
      })}
      required={required}
      value={value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
    />
  )
}

export default Time

Time.propTypes = {
  validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
}

Time.defaultProps = {
  validations: {},
  onChange: () => {},
  onBlur: () => {},
  value: '',
  required: false,
}
